/* Titan Landing — comportamiento del tema (sin dependencias) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Galería con flechas, puntos y miniaturas ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var track = $('.gal__track', g);
      var slides = $$('.gal__slide', g);
      var dots = $$('.gal__dot', g);
      var thumbs = $$('.gal__thumb', g);
      if (!track || !slides.length) return;
      function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function mark() {
        var i = idx();
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
        slides.forEach(function (s, n) {
          var v = $('video', s); if (v) { if (n === i) { v.play().catch(function () {}); } else { v.pause(); } }
        });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      var p = $('.gal__arrow--prev', g), n = $('.gal__arrow--next', g);
      if (p) p.addEventListener('click', function () { go(idx() - 1); });
      if (n) n.addEventListener('click', function () { go(idx() + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      mark();
    });
  }

  /* ---------- Pestañas con resaltado al hacer scroll ---------- */
  function initTabs() {
    var tabs = $('[data-tabs]'); if (!tabs) return;
    var links = $$('a', tabs);
    var targets = links.map(function (a) { return document.getElementById((a.getAttribute('href') || '').slice(1)); });
    function onScroll() {
      var y = window.scrollY + 120, cur = -1;
      targets.forEach(function (t, i) { if (t && t.offsetTop <= y) cur = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === cur); });
      if (cur > -1) { var a = links[cur]; tabs.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' }); }
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (t) { e.preventDefault(); window.scrollTo({ top: t.offsetTop - 100, behavior: 'smooth' }); }
      });
    });
  }

  /* ---------- Aparición ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Contadores de porcentaje ---------- */
  function initCounters() {
    var els = $$('[data-count]'); if (!els.length) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        var el = x.target, to = parseInt(el.getAttribute('data-count'), 10) || 0, t0 = performance.now();
        (function step(t) {
          var p = Math.min(1, (t - t0) / 1400);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + '%';
          if (p < 1) requestAnimationFrame(step);
        })(t0);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Videos tipo podcast: autoplay mudo, toque = sonido ---------- */
  function initPodcast() {
    var vids = $$('[data-pod-video]'); if (!vids.length) return;
    function muteAll(except) {
      vids.forEach(function (w) {
        var v = $('video', w); if (v !== except) { v.muted = true; var b = $('.pod__mute', w); if (b) b.textContent = '🔇'; }
      });
    }
    vids.forEach(function (w) {
      var v = $('video', w), b = $('.pod__mute', w);
      w.addEventListener('click', function () {
        if (v.muted) { muteAll(v); v.muted = false; v.currentTime = 0; v.play().catch(function () {}); if (b) b.textContent = '🔊'; }
        else { v.muted = true; if (b) b.textContent = '🔇'; }
      });
    });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (w) { $('video', w).play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var v = $('video', x.target);
        if (x.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); v.muted = true; var b = $('.pod__mute', x.target); if (b) b.textContent = '🔇'; }
      });
    }, { threshold: 0.5 });
    vids.forEach(function (w) { io.observe(w); });
  }

  /* ---------- Barra inferior fija ---------- */
  function initStickyBar() {
    var bar = $('[data-sbar]'), hero = $('[data-hero-cta]');
    if (!bar) return;
    document.body.classList.add('has-sbar');
    function check() {
      var show = true;
      if (hero) { var r = hero.getBoundingClientRect(); show = r.bottom < 0; }
      bar.classList.toggle('is-on', show);
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(check); }, { passive: true });
    check();
  }

  /* ---------- Popup de oferta (una vez por sesión) ---------- */
  function initPopup() {
    var pop = $('[data-pop]'); if (!pop) return;
    var mode = pop.getAttribute('data-trigger') || 'exit';
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 25) * 1000;
    function open() { if (store.get('tl_pop')) return; pop.classList.add('is-on'); store.set('tl_pop', '1'); }
    function close() { pop.classList.remove('is-on'); }
    $$('[data-pop-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    if (mode === 'time') { setTimeout(open, delay); return; }
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) open(); });
    var lastY = window.scrollY, fast = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY; if (lastY - y > 90 && y > 600) { fast++; if (fast > 1) open(); } lastY = y;
    }, { passive: true });
    setTimeout(open, delay * 3);
  }

  /* ---------- Reseñas: ver más ---------- */
  function initReviews() {
    $$('[data-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.rev.is-hidden', btn.parentNode).forEach(function (r) { r.classList.remove('is-hidden'); });
        btn.remove();
      });
    });
  }

  /* ---------- Variante seleccionada actualiza precio e id ---------- */
  function initVariants() {
    $$('[data-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var form = document.getElementById(sel.getAttribute('data-form')) || sel.closest('form');
        var idInput = form && $('[name=id]', form);
        var opt = sel.options[sel.selectedIndex];
        if (idInput) idInput.value = opt.value;
        var priceEl = $('[data-price-now]'); if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
        var btn = $('[data-add]', form);
        if (btn) { var av = opt.getAttribute('data-available') === 'true'; btn.disabled = !av; }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initGallery(); initTabs(); initReveal(); initCounters();
    initPodcast(); initStickyBar(); initPopup(); initReviews(); initVariants();
  });
})();
